import { render, staticRenderFns } from "./PortfolioDetail.vue?vue&type=template&id=82ea264c&scoped=true&"
import script from "./PortfolioDetail.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetail.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDetail.vue?vue&type=style&index=0&id=82ea264c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ea264c",
  null
  
)

export default component.exports